module.exports = __webpack_public_path__ + "assets/123e5d40c7e050814a38dcf82ea5e07e.mp3";